import { gql } from '@apollo/client';

/**
 * 大包差异 tab 差异大包下钻 drawer「导出大包明细」mutation：
 * 每行 = 一个大包，与 drawer 显示的 cartonColumns 同源。
 * filter 字段与 GET_WORK_PROGRESS_CLIENT_CARTONS（WorkProgressBagDetailFilterInput）对齐。
 */
export const GENERATE_WORK_PROGRESS_BAG_DETAIL_DRILLDOWN_DOWNLOAD_REPORT = gql`
  mutation GenerateWorkProgressBagDetailDrilldownDownloadReport(
    $filter: WorkProgressBagDetailDrilldownExportFilterInput!
    $timezone: String
  ) {
    generateWorkProgressBagDetailDrilldownDownloadReport(filter: $filter, timezone: $timezone)
  }
`;

export interface WorkProgressBagDetailDrilldownExportFilterInput {
  hubId: number;
  /** 大包差异 tab 下钻专用：非空时后端按 pre_pickup_hub_id 过滤、忽略 hubId */
  prePickupHubId?: number | null;
  arrivalDateStart: string;
  arrivalDateEnd: string;
  customerId?: number | null;
  bigBagNo?: string | null;
  mawb?: string | null;
  /** 未传 mawb、bigBagNo 时的默认大包类型（一般为 1） */
  bagType?: number | null;
  /** false=仅未入库，true=仅已入库；不传/null 时后端不拼 is_inbound 条件 */
  isInbound?: boolean | null;
  /** true：仅查询已入库大包口径 */
  inboundBagOnly?: boolean | null;
}

export interface GenerateWorkProgressBagDetailDrilldownDownloadReportVariables {
  filter: WorkProgressBagDetailDrilldownExportFilterInput;
  timezone?: string;
}

export interface GenerateWorkProgressBagDetailDrilldownDownloadReportResponse {
  generateWorkProgressBagDetailDrilldownDownloadReport: string;
}
